import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { USER_ACTIONS, USER_NAV } from "../../../../routes/APP_ROUTES";
import { useAuth } from "../../../../providers/AuthContext";
import Modal from "../../../ui/Modal";
import { RiLogoutBoxRLine } from "react-icons/ri";
import AccountSettings from "../../../../pages/User/AccountSetting";
import { isImageUrl } from "../../../../helpers/functions";
import { useSportsbook } from "../../../../providers/SportsbookContext";
import ChangePassword from "../../../../pages/Auth/ChangePassword";

const UserSettings = () => {
  const { logout, user } = useAuth();
  const { sendMessageToSportsbook } = useSportsbook();
  const [isChangePasswordOpen, setIsChangePasswordOpen] = useState(false);
  const { t } = useTranslation();
  let isUserRole = user?.role === "User";
  const navigate = useNavigate();

  const [isTablet, setIsTablet] = useState(window?.innerWidth <= 1024);
  const [isMobile, setIsMobile] = useState(window?.innerWidth <= 768);

  // const [isUserSettingsModalOpen, setIsUserSettingsModalOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const userNav = USER_NAV();

  const handleUserActions = (path) => {
    navigate(`/user/${path}`);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsTablet(window.innerWidth <= 1024);
      setIsMobile(window.innerWidth <= 480);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  let filterNav = userNav.filter((fi) => fi.path === "my-account" || fi.path === "deposit" || fi.path === "withdraw");

  return (
    <>
    {isChangePasswordOpen && (
        <Modal
          isOpen={isChangePasswordOpen}
          onClose={() => setIsChangePasswordOpen(false)}
          title={""}
          className="max-w-lg w-full"
        >
          <ChangePassword onClose={() => setIsChangePasswordOpen(false)} />
        </Modal>
      )}
      <div className="flex flex-col h-full">
        <div className="user-setting-dd lg:h-auto flex-grow overflow-y-auto bg-[#44485c]">
          {filterNav
            .filter((fi) => {
              if (isUserRole) {
                return true;
              }
              return fi.title === t("My Account");
            })
            .map((item, index) => (
              <button
                type="button"
                key={index}
                className={`sm:border-b border-white border-opacity-10 w-full flex items-center gap-2 hover:text-primary px-4 py-3 text-sm text-white [&_svg_path]:hover:fill-primary [&_svg]:w-8 [&_svg]:h-6 ${
                  index === selectedIndex ? "active" : ""
                }`}
                onClick={(e) => handleUserActions(item.path)}
              >
                {/* {isImageUrl(item.image) ? <img className="w-6 h-6" src={item.image} alt={item.title} /> : item.image} */}
                {item.label}
              </button>
            ))}
          {/* Logout button */}
          <button
            className="sm:border-b border-white border-opacity-10 w-full flex items-center gap-2 hover:text-primary px-4 py-3 text-sm text-white [&_svg_path]:hover:fill-primary [&_svg]:w-8 [&_svg]:h-6"
            // className="flex items-center justify-center gap-1 bg-primary text-primary-dark px-3 md:py-[6px] py-3 rounded-lg hover:bg-primary transition cursor-pointer w-full"
            onClick={() => {
              logout();
              sendMessageToSportsbook({ logout: "" });
              navigate("/sportsbook/sports");
            }}
          >
            {/* <RiLogoutBoxRLine size={20} /> */}
            {t("Logout")}
          </button>
          {user.role !=="Owner" && user.role !=="User" && <button
            className="sm:border-b border-white border-opacity-10 w-full flex items-center gap-2 hover:text-primary px-4 py-3 text-sm text-white [&_svg_path]:hover:fill-primary [&_svg]:w-8 [&_svg]:h-6"
            // className="flex items-center justify-center gap-1 bg-primary text-primary-dark px-3 md:py-[6px] py-3 rounded-lg hover:bg-primary transition cursor-pointer w-full"
            onClick={() => setIsChangePasswordOpen(true)}
          >
            {/* <RiLogoutBoxRLine size={20} /> */}
            {t("Change Password")}
          </button>}
        </div>
      </div>
    </>
  );
};

export default UserSettings;
